// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Button } from '@iheartjane/reefer';

export const ThemedButton = styled(Button)<{ janePay: boolean }>(
  ({ janePay, theme }) => ({
    ...(janePay && {
      backgroundColor: theme.colors.brand.purple.main,
      borderColor: theme.colors.brand.purple.main,
      '*': {
        color: theme.colors.grays.white,
      },
      '[class*="loading__wavvy"]': {
        backgroundColor: theme.colors.grays.white,
      },
    }),
  })
);
